type ShadowLayer = {
  x: number;
  y: number;
  blur: number;
  spread: number;
  opacity: number;
};

export function buildBoxShadow(layers: readonly ShadowLayer[]): string {
  return layers
    .map((layer) => `${layer.x}px ${layer.y}px ${layer.blur}px ${layer.spread}px rgba(0, 0, 0, ${layer.opacity})`)
    .join(', ');
}

const ELEVATION_LAYERS = {
  raised1: [
    { x: 0, y: 2, blur: 8, spread: 0, opacity: 0.04 },
    { x: 0, y: 1, blur: 2, spread: 0, opacity: 0.06 },
  ],
  raised2: [
    { x: 0, y: 6, blur: 16, spread: 0, opacity: 0.08 },
    { x: 0, y: 2, blur: 4, spread: 0, opacity: 0.06 },
  ],
  overlay1: [
    { x: 0, y: 4, blur: 8, spread: 0, opacity: 0.06 },
    { x: 0, y: 1, blur: 3, spread: 0, opacity: 0.06 },
  ],
  overlay2: [
    { x: 0, y: 8, blur: 16, spread: 0, opacity: 0.08 },
    { x: 0, y: 2, blur: 6, spread: 0, opacity: 0.08 },
  ],
  overlay3: [
    { x: 0, y: 12, blur: 24, spread: 0, opacity: 0.1 },
    { x: 0, y: 4, blur: 12, spread: 0, opacity: 0.1 },
  ],
  overlay4: [
    { x: 0, y: 24, blur: 48, spread: 0, opacity: 0.16 },
    { x: 0, y: 6, blur: 18, spread: 0, opacity: 0.12 },
  ],
} as const;

export const ELEVATION_TOKENS = {
  none: 'none',
  raised1: buildBoxShadow(ELEVATION_LAYERS.raised1),
  raised2: buildBoxShadow(ELEVATION_LAYERS.raised2),
  overlay1: buildBoxShadow(ELEVATION_LAYERS.overlay1),
  overlay2: buildBoxShadow(ELEVATION_LAYERS.overlay2),
  overlay3: buildBoxShadow(ELEVATION_LAYERS.overlay3),
  overlay4: buildBoxShadow(ELEVATION_LAYERS.overlay4),
} as const;

export type ElevationTokens = typeof ELEVATION_TOKENS;
export type ElevationTokenKey = keyof ElevationTokens;
export type ElevationTokenValue = ElevationTokens[ElevationTokenKey];
